<template>
    <RadarForm></RadarForm>
</template>

<script>
  import RadarForm from '../components/radar/RadarForm'
  export default {
    name: 'RadarCreator',
    components: { RadarForm }
  }
</script>

<style scoped>

</style>
